// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-heading[data-v-53b27283]{margin-top:0}.employment-details[data-v-53b27283]{margin-left:5%;margin-top:50px}", ""]);
// Exports
module.exports = exports;
